// Theirs
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// tslint:disable no-import-side-effect
import '../styles/angular-material/theming.scss?global';
// Ours modules
import { SashaRoutingModule } from './sasha.routing';
import '../styles/angular-material/list-option.scss?global';
import '../styles/angular-material/pseudo-checkbox.scss?global';
import '../styles/angular-material/selection-list.scss?global';
import '../styles/angular-material/checkbox.scss?global';
import '../styles/angular-material/select.scss?global';
import '../styles/angular-material/slide-toggle.scss?global';
import '../styles/angular-material/menu.scss?global';
import '../styles/angular-material/form-field.scss?global';
import '../styles/angular-material/chip-list.scss?global';
import '../styles/angular-material/tabs.scss?global';
import '../styles/angular-material/dialog.scss?global';
import { SashaBreadcrumbService } from "./shared/components/breadcrumb/sasha-breadcrumb.service";
import { SashaHomeModule } from './pages/sasha-home/sasha-home.module';
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { AfiMatDialogDefaultOptions } from "libraries/component/dialogs/afi-mat-dialog-default-options";
import { ProcessingModule } from "libraries/service/processing/processing.module";

@NgModule({
    imports: [
        CommonModule,
        SashaRoutingModule,
        ProcessingModule,
        SashaHomeModule,
    ],
    providers: [
        SashaBreadcrumbService,
        {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: new AfiMatDialogDefaultOptions()},
    ]
})
export class SashaModule { }
